import React from 'react';

export default class ReportGuidelines extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={'verification-details'}>
        <div className={'verification-details-header'}>{'VERIFICATION GUIDELINES'}</div>
        <div className={'verification-guidelines-wrapper'}>
          {this.props.docType === 'Aadhaar Card' ? (
            <div className={'guidelines-content'}>
              {
                'Government sources return information in form of ranges rather than the exact data of an individual to preserve privacy.'
              }
              <br />
              {'E.g: Instead of exact age, we get the age range.'}
            </div>
          ) : this.props.docType === 'PAN Card' ? (
            <div>
              <div className={'guidelines-content'}>
                {
                  "The government database does not share the father's name of a person. The father's name shown in the report is the one we picked up from the PAN document but cannot be verified from government sources."
                }
              </div>
              <div className={'guidelines-content'}>
                {
                  'The name printed on the PAN card is known to have small variations when compared to the government database. While "<First-Name> <Last-Name>" might be the name on the PAN card, it might be saved as "<Last-Name> <First-Name>" in the government database, which can lead to a mismatch.'
                }
              </div>
            </div>
          ) : this.props.docType === "Driver's License" ? (
            <div className={'guidelines-content'}>
              {
                'We get the Driving License number from the document uploaded and fetch futher details from government sources. No other data from the Driving License document is used.'
              }
            </div>
          ) : this.props.docType === 'Voter ID' ? (
            <div>
              <div className={'guidelines-content'}>
                {
                  'We get the Voter ID number from the document uploaded and fetch futher details from government sources. No other data from the Voter ID card is used.'
                }
              </div>
              <div className={'guidelines-content'}>
                {
                  'Government sources only return age and not the exact date of birth. The information above shows the age as found in the government database.'
                }
              </div>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
    );
  }
}

ReportGuidelines.defaultProps = {
  docType: null
};
